export class ZipcodeZone {
  constructor(
    public readonly id: string,
    public readonly zipcodesFrom: number,
    public readonly zipcodesTo: number,
    public readonly name: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly deletedAt: Date|null,
  ) {
  }

  static fromJson(json: any): ZipcodeZone {
    return new ZipcodeZone(
      json['id'],
      json['zipcodes_from'],
      json['zipcodes_to'],
      json['name'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['deleted_at'] ? new Date(json['deleted_at']) : null,
    )
  }
}